import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';

const DashboardAssinante = () => {
    const navigate = useNavigate();
    
    const [dadosDashboard, setDadosDashboard] = useState(null);
    const [loading, setLoading] = useState(true);

    // ESTADOS PARA RESPONSIVIDADE E MENU HAMBÚRGUER
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [menuAberto, setMenuAberto] = useState(false);

    // Escuta o redimensionamento da janela
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("@QuitaGo:token");

        if (!token || token === "undefined") {
            console.error("Usuário não autenticado");
            // window.location.href = "/login"; // Descomenta quando tiveres o fluxo de login finalizado
            return;
        }

        api.get('/assinante/minha-empresa')
            .then(res => {
                setDadosDashboard(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Erro na API:", err);
                setLoading(false);
            });
    }, []);

    const formatarMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', { 
            style: 'currency', 
            currency: 'BRL' 
        }).format(valor || 0);
    };

    // Função auxiliar para navegar e fechar o menu no celular
    const handleNavegar = (rota) => {
        navigate(rota);
        if (isMobile) setMenuAberto(false);
    };

    if (loading) {
        return (
            <div style={{ ...styles.container, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <svg width="60" height="60" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="25" cy="25" r="20" fill="none" stroke="#10b981" strokeWidth="4" 
                            strokeDasharray="80" strokeDashoffset="60" strokeLinecap="round">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 25 25;360 25 25"/>
                    </circle>
                </svg>
                <h2 style={{ color: 'white', marginTop: '20px', fontWeight: '600' }}>A preparar o teu painel...</h2>
                <p style={{ color: '#64748b', marginTop: '5px' }}>Buscando dados da empresa e credores</p>
            </div>
        );
    }

    if (!dadosDashboard) {
        return (
            <div style={{ ...styles.container, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ background: 'rgba(239, 68, 68, 0.1)', padding: '20px', borderRadius: '50%', marginBottom: '20px' }}>
                    <span style={{ fontSize: '3rem' }}>⚠️</span>
                </div>
                <h2 style={{ color: 'white', marginBottom: '10px' }}>Ops! Falha na conexão</h2>
                <p style={{ color: '#94a3b8', marginBottom: '25px', textAlign: 'center', maxWidth: '400px' }}>
                    Não foi possível buscar as informações neste momento. Verifica a tua conexão ou tenta novamente.
                </p>
                <button onClick={() => window.location.reload()} style={{ ...styles.btnAdd, padding: '12px 30px' }}>
                    Tentar Novamente
                </button>
            </div>
        );
    }

    const getImageUrl = (url) => {
        if (!url) return null;
        if (url.startsWith('http')) return url;
        return `${api.defaults.baseURL}${url}`;
    };

    // Estilos dinâmicos calculados
    const sidebarAtual = isMobile 
        ? { ...styles.sidebarMobile, transform: menuAberto ? 'translateX(0)' : 'translateX(-100%)' } 
        : styles.sidebarDesktop;

    const credorGridAtual = isMobile 
        ? { ...styles.credorGrid, gridTemplateColumns: '1fr' } 
        : styles.credorGrid;

    return (
        <div style={styles.container}>
            
            {/* INJEÇÃO DE CSS PARA O EFEITO PISCAR */}
            <style>
                {`
                    @keyframes piscarAlerta {
                        0% { background-color: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.3); box-shadow: 0 0 0 rgba(239, 68, 68, 0); }
                        50% { background-color: rgba(239, 68, 68, 0.3); border-color: rgba(239, 68, 68, 0.8); box-shadow: 0 0 20px rgba(239, 68, 68, 0.4); }
                        100% { background-color: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.3); box-shadow: 0 0 0 rgba(239, 68, 68, 0); }
                    }
                    .alerta-prescricao {
                        animation: piscarAlerta 2s infinite;
                    }
                `}
            </style>

            {/* OVERLAY ESCURO (Só aparece no mobile quando o menu está aberto) */}
            {isMobile && menuAberto && (
                <div style={styles.overlay} onClick={() => setMenuAberto(false)} />
            )}

            {/* MENU LATERAL (SIDEBAR) */}
            <aside style={sidebarAtual}>
                <div style={styles.sidebarHeader}>
                    {isMobile && (
                        <button onClick={() => setMenuAberto(false)} style={styles.btnClose}>✖</button>
                    )}
                </div>

                <nav style={styles.nav}>
                    <button onClick={() => handleNavegar('/dashboard')} style={styles.navItemActive}>
                        📊 Dashboard
                    </button>
                    <button onClick={() => handleNavegar('/cobranca')} style={styles.navItem}>
                        🎯 Cobrança Inteligente
                    </button>
                    <button onClick={() => handleNavegar('/acordos')} style={styles.navItem}>
                        🤝 Meus Acordos
                    </button>
                    <button onClick={() => handleNavegar('/configuracoes/whatsapp')} style={styles.navItemWhatsapp}>
                        📱 Conectar WhatsApp
                    </button>
                    <button onClick={() => handleNavegar('/configuracoes')} style={styles.navItem}>
                        ⚙️ Configurações
                    </button>
                </nav>
            </aside>

            {/* CONTEÚDO PRINCIPAL */}
            <main style={styles.content}>
                
                <header style={styles.header}>
                    <div style={styles.headerTopLine}>
                        {isMobile && (
                            <button onClick={() => setMenuAberto(true)} style={styles.btnBurger}>
                                ☰
                            </button>
                        )}
                        <div>
                            <h1 style={styles.title}>Painel de {dadosDashboard.razaoSocial}</h1>
                            <p style={{color: '#94a3b8', margin: '5px 0 0 0'}}>Plano atual: <strong>{dadosDashboard.nomePlano}</strong></p>
                        </div>
                    </div>
                    
                    {!isMobile && (
                        <div style={styles.userProfile}>Assinante Master</div>
                    )}
                </header>

                {/* 🔥 BANNER DE ALERTA DE PRESCRIÇÃO 🔥 */}
                {/* O banner só aparece se o back-end enviar um totalRiscoPrescricao maior que 0 */}
                {dadosDashboard.totalRiscoPrescricao > 0 && (
                    <div 
                        className="alerta-prescricao" 
                        style={styles.bannerAlerta}
                        onClick={() => navigate('/cobranca')} 
                        title="Clique para ir ao Painel de Cobrança e filtrar por Risco de Prescrição"
                    >
                        <span style={{ fontSize: '1.8rem', marginRight: '15px' }}>⚠️</span>
                        <div>
                            <strong style={{ display: 'block', fontSize: '1.1rem' }}>ALERTA DE PRESCRIÇÃO JURÍDICA</strong>
                            Tens <strong>{dadosDashboard.totalRiscoPrescricao} dívida(s)</strong> prestes a completar 5 anos. Clica aqui para negociar ou ajuizar antes de perderes o direito de cobrança!
                        </div>
                    </div>
                )}

                <section style={styles.gridStats}>
                    <div style={styles.cardStat}>
                        <p style={styles.statLabel}>Credores Ativos</p>
                        <h3 style={styles.statValue}>
                            {dadosDashboard.credoresCadastrados} / {dadosDashboard.limiteCredores}
                        </h3>
                        <div style={styles.progressBarBg}>
                            <div style={{
                                ...styles.progressBarFill, 
                                width: `${(dadosDashboard.credoresCadastrados / dadosDashboard.limiteCredores) * 100}%`
                            }} />
                        </div>
                    </div>

                    <div style={styles.cardStat}>
                        <p style={styles.statLabel}>Total a Receber</p>
                        <h3 style={{...styles.statValue, color: '#10b981'}}>
                            {formatarMoeda(dadosDashboard.valorTotalGeral)}
                        </h3>
                    </div>

                    <div style={styles.cardStat}>
                        <p style={styles.statLabel}>Em Ação Judicial</p>
                        <h3 style={{...styles.statValue, color: '#f59e0b'}}>
                            {dadosDashboard.totalGeralProcessos}
                        </h3>
                    </div>

                    <div style={styles.cardStat}>
                        <p style={styles.statLabel}>Negativados</p>
                        <h3 style={{...styles.statValue, color: '#ef4444'}}>
                            {dadosDashboard.totalGeralNegativados}
                        </h3>
                    </div>
                </section>

                <section style={styles.tableSection}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', marginBottom: '20px', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '15px' : '0' }}>
                        <h2 style={{ ...styles.sectionTitle, marginBottom: 0 }}>Meus Credores e Ocupação</h2>
                        
                        {/* ÁREA DE BOTÕES */}
                        <div style={{ display: 'flex', gap: '10px', width: isMobile ? '100%' : 'auto', flexWrap: 'wrap' }}>
                            <button onClick={() => navigate('/devedores/novo')} style={{...styles.btnSecondary, flex: isMobile ? '1 1 100%' : 'none'}}>
                                + Novo Devedor
                            </button>
                            
                            <button onClick={() => navigate('/acordos')} style={{...styles.btnWarning, flex: isMobile ? '1 1 100%' : 'none'}}>
                                🤝 Listar Acordos
                            </button>

                            <button onClick={() => navigate('/credores/novo')} style={{...styles.btnAdd, flex: isMobile ? '1 1 100%' : 'none'}}>
                                + Novo Credor
                            </button>
                        </div>
                    </div>
                    
                    <div style={credorGridAtual}>
                        {dadosDashboard.meusCredores && dadosDashboard.meusCredores.length > 0 ? (
                            dadosDashboard.meusCredores.map(credor => (
                                <div key={credor.id} style={styles.credorCard}>
                                    
                                    <div style={styles.credorHeader}>
                                        {credor.logoUrl ? (
                                            <img src={getImageUrl(credor.logoUrl)} alt={`Logo`} style={styles.credorLogo} />
                                        ) : (
                                            <div style={styles.credorLogoFallback}>
                                                {credor.nomeExibicao.charAt(0).toUpperCase()}
                                            </div>
                                        )}
                                        
                                        <div style={styles.credorHeaderText}>
                                            <strong style={{ fontSize: '1.1rem' }}>{credor.nomeExibicao}</strong>
                                            <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
                                                {credor.devedoresAtuais} / {dadosDashboard.limiteDevedoresPorCredor} devedores
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div style={styles.progressBarBg}>
                                        <div style={{
                                            ...styles.progressBarFill, 
                                            width: `${credor.percentualUso || 0}%`,
                                            background: credor.percentualUso > 80 ? '#ef4444' : '#10b981' 
                                        }} />
                                    </div>

                                    <div style={styles.credorDetailsGrid}>
                                        <div>
                                            <span style={styles.detailLabel}>A Receber</span>
                                            <strong style={{ color: '#10b981', display: 'block' }}>
                                                {formatarMoeda(credor.valorTotalReceber)}
                                            </strong>
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <span style={styles.detailLabel}>Processos</span>
                                            <strong style={{ color: '#f59e0b', display: 'block' }}>{credor.processosJudiciais}</strong>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <span style={styles.detailLabel}>Negativados</span>
                                            <strong style={{ color: '#ef4444', display: 'block' }}>{credor.negativados}</strong>
                                        </div>
                                    </div>

                                </div>
                            ))
                        ) : (
                            <div style={styles.tablePlaceholder}>Ainda não cadastraste nenhum credor.</div>
                        )}
                    </div>
                </section>
            </main>
        </div>
    );
};

const styles = {
    container: { display: 'flex', minHeight: '100vh', background: '#020617', color: 'white', fontFamily: 'sans-serif' },
    
    // Sidebar
    sidebarDesktop: { width: '260px', background: 'rgba(255,255,255,0.02)', borderRight: '1px solid rgba(255,255,255,0.1)', padding: '30px', flexShrink: 0 },
    sidebarMobile: { position: 'fixed', top: 0, left: 0, height: '100vh', width: '280px', background: '#0f172a', zIndex: 1000, padding: '30px', transition: 'transform 0.3s ease', borderRight: '1px solid rgba(255,255,255,0.1)', boxShadow: '4px 0 15px rgba(0,0,0,0.5)' },
    overlay: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0, 0, 0, 0.7)', zIndex: 999 },
    sidebarHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' },
    logo: { fontSize: '1.5rem', fontWeight: '800', margin: 0 },
    btnClose: { background: 'transparent', border: 'none', color: '#94a3b8', fontSize: '1.2rem', cursor: 'pointer' },
    btnBurger: { background: 'transparent', border: 'none', color: '#10b981', fontSize: '1.8rem', cursor: 'pointer', padding: '0 15px 0 0' },
    
    // Nav
    nav: { display: 'flex', flexDirection: 'column', gap: '10px' },
    navItem: { background: 'none', border: 'none', color: '#94a3b8', textAlign: 'left', padding: '12px', cursor: 'pointer', borderRadius: '8px', transition: 'background 0.2s', fontSize: '0.95rem' },
    navItemActive: { background: 'rgba(16, 185, 129, 0.1)', border: 'none', color: '#10b981', textAlign: 'left', padding: '12px', borderRadius: '8px', fontWeight: 'bold', fontSize: '0.95rem' },
    navItemWhatsapp: { background: 'rgba(34, 197, 94, 0.15)', border: '1px solid rgba(34, 197, 94, 0.3)', color: '#22c55e', textAlign: 'left', padding: '12px', cursor: 'pointer', borderRadius: '8px', transition: 'all 0.2s', fontSize: '0.95rem', fontWeight: 'bold', marginTop: '10px' },
    
    // Main Content
    content: { flex: 1, padding: 'clamp(20px, 5vw, 40px)', width: '100%', boxSizing: 'border-box' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' },
    headerTopLine: { display: 'flex', alignItems: 'center' },
    title: { fontSize: 'clamp(1.2rem, 3vw, 1.8rem)', fontWeight: '700', margin: 0 },
    userProfile: { background: 'rgba(255,255,255,0.05)', padding: '8px 15px', borderRadius: '20px', fontSize: '0.8rem', whiteSpace: 'nowrap' },
    
    // 🔥 ESTILO DO BANNER DE ALERTA (Piscante) 🔥
    bannerAlerta: { 
        display: 'flex', 
        alignItems: 'center', 
        color: '#fca5a5', 
        border: '1px solid rgba(239, 68, 68, 0.5)', 
        padding: '15px 25px', 
        borderRadius: '12px', 
        marginBottom: '30px', 
        cursor: 'pointer',
        transition: 'transform 0.2s',
    },

    // Cards Superiores
    gridStats: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', marginBottom: '40px' },
    cardStat: { background: 'rgba(255,255,255,0.03)', padding: '25px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' },
    statLabel: { color: '#94a3b8', fontSize: '0.9rem', marginBottom: '10px' },
    statValue: { fontSize: '1.8rem', fontWeight: '800', margin: '5px 0' },
    
    // Tabela/Grid de Credores
    tableSection: { background: 'rgba(255,255,255,0.03)', borderRadius: '12px', padding: 'clamp(15px, 4vw, 30px)' },
    sectionTitle: { fontSize: '1.2rem' },
    tablePlaceholder: { color: '#475569', textAlign: 'center', padding: '40px', width: '100%' },
    
    // Progresso
    progressBarBg: { width: '100%', height: '8px', background: 'rgba(255,255,255,0.1)', borderRadius: '4px', marginTop: '15px', overflow: 'hidden' },
    progressBarFill: { height: '100%', background: '#10b981', borderRadius: '4px', transition: 'width 0.5s ease' },
    
    // Cards Internos (Clínicas)
    credorGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
    credorCard: { background: 'rgba(255,255,255,0.02)', padding: '20px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.05)' },
    credorHeader: { display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '5px' },
    credorHeaderText: { display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 },
    credorLogo: { width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)', flexShrink: 0 },
    credorLogoFallback: { width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(16, 185, 129, 0.2)', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 'bold', border: '2px solid rgba(16, 185, 129, 0.5)', flexShrink: 0 },
    credorDetailsGrid: { display: 'flex', justifyContent: 'space-between', marginTop: '20px', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '15px' },
    detailLabel: { display: 'block', fontSize: '0.8rem', color: '#64748b', marginBottom: '4px' },
    
    // Botões
    btnAdd: { background: '#10b981', color: '#022c22', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'background 0.3s' },
    btnSecondary: { background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', border: '1px solid #10b981', padding: '10px 20px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s' },
    btnWarning: { background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b', border: '1px solid #f59e0b', padding: '10px 20px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s' }
};

export default DashboardAssinante;